const productSuppliers = [
	{
		path: '/deals/product-suppliers',
		name: 'shop-product-suppliers-list',
		component: () => import('@/views/shop/productSuppliers/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,product-suppliers',
		},
	},
]

export default productSuppliers
